import React, { useState } from 'react';
import { User, Calendar } from 'lucide-react';
interface TaskStepEditorProps {
  assignTo: string;
  taskDetails: string;
  priority: 'High' | 'Medium' | 'Low';
  onUpdate: (data: {
    assignTo: string;
    taskDetails: string;
    priority: string;
  }) => void;
}
const TaskStepEditor: React.FC<TaskStepEditorProps> = ({
  assignTo,
  taskDetails,
  priority,
  onUpdate
}) => {
  const [currentAssignTo, setCurrentAssignTo] = useState(assignTo);
  const [currentTaskDetails, setCurrentTaskDetails] = useState(taskDetails);
  const [currentPriority, setCurrentPriority] = useState(priority);
  const handleAssignToChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentAssignTo(e.target.value);
    onUpdate({
      assignTo: e.target.value,
      taskDetails: currentTaskDetails,
      priority: currentPriority
    });
  };
  const handleTaskDetailsChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCurrentTaskDetails(e.target.value);
    onUpdate({
      assignTo: currentAssignTo,
      taskDetails: e.target.value,
      priority: currentPriority
    });
  };
  const handlePriorityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setCurrentPriority(e.target.value as 'High' | 'Medium' | 'Low');
    onUpdate({
      assignTo: currentAssignTo,
      taskDetails: currentTaskDetails,
      priority: e.target.value
    });
  };
  return <div className="space-y-6" data-id="element-269">
      <h3 className="text-lg font-medium" data-id="element-270">Create HubSpot Task</h3>
      <div className="space-y-4" data-id="element-271">
        <div data-id="element-272">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-273">
            Assign To
          </label>
          <div className="flex items-center" data-id="element-274">
            <div className="relative flex-1" data-id="element-275">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-276">
                <User size={16} className="text-gray-400" data-id="element-277" />
              </div>
              <select value={currentAssignTo} onChange={handleAssignToChange} className="block w-full pl-10 pr-3 py-2 bg-white border border-gray-300 rounded-md text-sm" data-id="element-278">
                <option value={Account.Owner} data-id="element-279">{Account.Owner}</option>
                <option value={Account.CSM} data-id="element-280">{Account.CSM}</option>
                <option value="Specific User" data-id="element-281">Specific User</option>
              </select>{' '}
            </div>
          </div>
        </div>
        <div data-id="element-282">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-283">
            Task Details
          </label>
          <textarea value={currentTaskDetails} onChange={handleTaskDetailsChange} className="w-full px-3 py-2 border border-gray-300 rounded-md min-h-[100px]" placeholder="Enter task description..." data-id="element-284" />
        </div>
        <div className="flex gap-4" data-id="element-285">
          <div className="flex-1" data-id="element-286">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-287">
              Priority
            </label>
            <select value={currentPriority} onChange={handlePriorityChange} className="block w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm" data-id="element-288">
              <option value="High" data-id="element-289">High</option>
              <option value="Medium" data-id="element-290">Medium</option>
              <option value="Low" data-id="element-291">Low</option>
            </select>
          </div>
          <div className="flex-1" data-id="element-292">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-293">
              Due Date
            </label>
            <div className="relative" data-id="element-294">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-295">
                <Calendar size={16} className="text-gray-400" data-id="element-296" />
              </div>
              <select className="block w-full pl-10 pr-3 py-2 bg-white border border-gray-300 rounded-md text-sm" data-id="element-297">
                <option value="same_day" data-id="element-298">Same day</option>
                <option value="next_day" data-id="element-299">Next business day</option>
                <option value="two_days" data-id="element-300">In 2 business days</option>
                <option value="one_week" data-id="element-301">In 1 week</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default TaskStepEditor;